import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

const CollateralListView = lazy(() => import('./views/CollateralListView'));
const CollateralDetailView = lazy(() => import('./views/CollateralDetailView'));

const LoadingFallback = () => (
    <div className="flex justify-center items-center h-full p-8">
        <Spin size="large" tip="Loading..." />
    </div>
);

export const collateralRoutes: RouteObject[] = [
    {
        path: '/collaterals',
        element: (
            <Suspense fallback={<LoadingFallback />}>
                <CollateralListView />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/collaterals/:id',
        element: (
            <Suspense fallback={<LoadingFallback />}>
                <CollateralDetailView />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />,
    },
];
